<template>
  <div>
    <div class="p404 bg-cercles">
      <div class="p404__content">
        <!-- <img
          class="p404__favicon"
          src="../assets/img/logos/favicon.svg"
          alt=""
        /> -->
        <h2 class="p404__title">{{ $t("emailPreferences.subscribeTitle") }}</h2>
        <p>
          {{ $t("emailPreferences.subscribeMessage") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "SubscribeBridge",
  metaInfo() {
    return {
      title: "Subscribed" + " | HelloBB",
      meta: [
        { name: "description", content: "You have been subscribed successfully." },
        { name: "robots", content: "noindex"},
      ]
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "isAuthenticated",
      isApp: "isApp"
    }),
  },
  methods: {
    setLanguage() {
      if (typeof window === "undefined") return;
      if(this.isAuthenticated) return;
      let langUrl = new URLSearchParams(window.location.search).get("lang") || "es";
      //get first two letters
      langUrl = langUrl.substring(0, 2).toLowerCase();
      if(langUrl == "fr") {
        this.lang = "fr-FR";
      } else if(langUrl == "it") {
        this.lang = "it-IT";
      }
      else if(langUrl == "en") {
        this.lang = "en-GB";
      }
      else {
        this.lang = "es";
      }
      this.$i18n.locale = this.lang;
    }
  },
  mounted() {
    this.setLanguage();
    //get 'group' param query string
    const groupParam = this.$route.query.group;
    //get 'data' param query string
    const dataParam = this.$route.query.data;
    if (dataParam) {
      window.mixpanel.track("subscribe page visited", {
        group: groupParam || "unknown",
        origin: "email"
      });
      //use the API to unsubscribe (https://af-email-sender.azurewebsites.net/api/UnsubscribeEmailByKey?code=bYHYyhqxcTBD-89eP3ofwg0dDV_64iA4scb2Q0DiQroXAzFuo5X1ug==), with payload { data: dataParam }
      fetch("https://af-email-sender.azurewebsites.net/api/UnsubscribeEmailByKey?code=7nv0Fe-PYtELLlFxp36l-V0AHb_RHg6vJGNFiFjoA8y0AzFuWAnykg==", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ data: dataParam })
      }).then(response => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
      }).then(() => {
        // if isApp go back in history waiting 3 seconds
        if (this.isApp) {
          setTimeout(() => {
            window.history.back();
          }, 2000);
        }
      }).catch(error => {
        if (this.isApp) {
          setTimeout(() => {
            window.history.back();
          }, 2000);
        }
        console.error("There was a problem with the fetch operation:", error);
      });
    }
    else {
      const group = this.$route.query.group;
      window.mixpanel.track("subscribe page visited", {
        group: group || "unknown",
        origin: "modal"
      });
      if (group) {
        this.$store.dispatch("subscribeToEmail", { action: "optin", group: group })
        .then(() => {
          console.log("Email preferences updated");
        }).then(() => {
          // if isApp go back in history waiting 3 seconds
          if (this.isApp) {
            setTimeout(() => {
              window.history.back();
            }, 2000);
          }
        }).catch(error => {
          if (this.isApp) {
            setTimeout(() => {
              window.history.back();
            }, 2000);
          }
          console.error("Error updating email preferences:", error);
        });
      }
    }
  }
};
</script>

<style scoped>
p {
  font-size: 1.2rem;
  line-height: 1.5;
  max-width: 60%; /* O el ancho máximo que prefieras */
  margin: 0 auto; /* Esto centra el contenedor horizontalmente */
}

@media (max-width: 768px) {
  p {
    font-size: 1rem; /* Tamaño de fuente más pequeño para móviles */
    line-height: 1.4; /* Ajuste del interlineado para mejorar la legibilidad en pantallas pequeñas */
    max-width: 90%;
  }
}
</style>
